import { CostTableRow } from "../types/CostTableRow";

export const addOnSuggestions: CostTableRow[] = [
  {
    id: "support_basic",
    name: "Support - Basic",
    listPrice: 0,
    discount: 0,
    amount: 1,
    isAddedManually: false,
  },
  {
    id: "support_advanced",
    name: "Support - Advanced",
    listPrice: 199,
    discount: 0,
    amount: 1,
    isAddedManually: false,
  },
  {
    id: "support_premium",
    name: "Support - Premium",
    listPrice: 395,
    discount: 0,
    amount: 1,
    isAddedManually: false,
  },
  {
    id: "hubspot",
    name: "HubSpot",
    listPrice: 149,
    discount: 0,
    amount: 1,
    isAddedManually: false,
  },
  {
    id: "salesforce",
    name: "SalesForce",
    listPrice: 199,
    discount: 0,
    amount: 1,
    isAddedManually: false,
  },
  {
    id: "api",
    name: "REST API",
    listPrice: 349,
    discount: 0,
    amount: 1,
    isAddedManually: false,
  },
  {
    id: "zapier",
    name: "Zapier",
    listPrice: 99,
    discount: 0,
    amount: 1,
    isAddedManually: false,
  },
  {
    id: "on_prem",
    name: "Regional Hosting",
    listPrice: 1000,
    discount: 0,
    amount: 1,
    isAddedManually: false,
  },
  {
    id: "sso_ad",
    name: "Single Sign-On (SSO) / Active Directory (AD)",
    listPrice: 110,
    discount: 0,
    amount: 1,
    isAddedManually: false,
  },
];
